
export default {
  name: 'MortgageCalculatorFInputPlaceholder',
};
